
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Returns the appropriate theme-aware background class based on the current theme and darkroom mode
 */
export function getThemeAwareBackgroundClass(isDarkMode: boolean, isDarkroomMode: boolean): string {
  if (isDarkroomMode) {
    return 'bg-black';
  } else if (isDarkMode) {
    return 'dark:bg-background bg-background';
  } else {
    return 'bg-background dark:bg-background';
  }
}

/**
 * Returns the appropriate theme-aware text class based on the current theme and darkroom mode
 */
export function getThemeAwareTextClass(isDarkMode: boolean, isDarkroomMode: boolean): string {
  if (isDarkroomMode) {
    return 'text-red-500';
  } else if (isDarkMode) {
    return 'text-foreground dark:text-foreground';
  } else {
    return 'text-foreground dark:text-foreground';
  }
}
